<template>
  <div style="background: #fff;width:100%;height:auto;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Cart</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin:30px 118px 78px 118px;">
      <div style="font-size:24px;color:#000;font-weight:bold;margin:">Your Cart</div>
      <!-- <div style="font-size:16px;color:#00546a;margin:24px 0 30px 0;">Continue Shopping l Save Cart I Request Quote l  Export Cart</div> -->
      <div>
        <div style="width:100%;height:1px;box-shadow: 0 0 1px rgba(111, 107, 97, 0.1)"></div>
        <el-table
          ref="multipleTable"
          :show-header="false"
          :data="cartList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column
            width="170">
            <template slot-scope="scope" style="">
              <img :src="scope.row.productImage" style="width:122px;height:122px;margin-top:10px;" />
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <p style="font-size:20px;font-weight:bold;margin-bottom:10px;"><span style="color:#343434;margin-right:18px;">{{ scope.row.productName }}</span>
                <!-- <span style="color:#8d8d8d;">产品型号|编号</span> -->
              </p>
              <p style="min-width:378px;background:#e8f1e5;color:#6f9d65;padding:5px 0 0px 10px;font-size:16px;">{{ scope.row.productInventory }}</p>
              <p style="min-width:378px;background:#e8f1e5;padding:0 0 5px 10px;font-size:16px;color:#8d8d8d;">Complete order quantity available for immediate delivery.</p>
              <p style="font-size:18px;color:#00718c;margin-top:10px;"><a >Add to Saved List</a>
                <!-- <span style="margin:0 6px;">|</span><a>Request Quote</a> -->
              </p>
            </template>
          </el-table-column>
          <el-table-column
            width="300">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.num" @change="handleChange(scope.row)" :min="0" label=""></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            width="120">
            <template slot-scope="scope">
              <p style="font-size:20px;font-weight:bold;color:#00718c" v-if="scope.row.productPrice > 0">${{ scope.row.productPrice }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div style="font-size:20px;display:flex;align-items:center;flex-direction: row;justify-content: space-between;margin-top:30px;">
          <div>
            <el-checkbox style="color:#000;" v-model="checked" @change="checkAll">Select all</el-checkbox>
          </div>
          <div style="width:380px;display:flex;align-items:center;flex-direction: row;justify-content: space-between;">
            <p style="width:120px;text-align:center;">Item:{{ total }}</p>
            <div style="text-align:right;padding-right:30px;">
              <p style="font-weight:bold;margin-bottom:12px;">Total:<span style="color:#00718c">${{ totalPrice }}</span></p>
              <p style="color:#8d8d8d;font-size:14px;">Excludes Shipping and Handling</p>
            </div>
          </div>
        </div>
        <div style="text-align:right;padding-right:30px;margin:50px 0;"><a class="a1" @click="sumbitCart" style="padding:18px 23px;background:#00718c;color:#fff;font-size:18px;font-weight:bold;border-radius:6px;">CHECKOUT</a></div>
        <div style="width:100%;height:1px;box-shadow: 0 0 1px rgba(111, 107, 97, 0.1)"></div>
      </div>
    </div>
  </div>
</template>
<script>
    import * as math from "mathjs"
    import { cartList, cartAdd } from '@/api/index' ;
    export default {
        name: 'Cart',
        components: {},
        data () {
            return {
              cartList: [],
              checked: false,
              multipleSelection: [],
              // total: 0,
              // totalPrice: 0,
              // sumitList: [],
            }
        },
        computed:{
          totalPrice(){
            const num = this.multipleSelection.reduce((pre,cur) => math.format(math.add(math.bignumber(pre),math.multiply(math.bignumber(cur.num || 0),math.bignumber(cur.productPrice || 0) ))),0)
            return num || 0
          },
          total(){
            return this.multipleSelection.reduce((pre,cur) => math.format(math.add(math.bignumber(pre),math.bignumber(cur.num || 0))),0)
          },
          // sumitList() {
          //   return this.multipleSelection.forEach(v => { productId: v.productId, num: v.num})
          // }
        },
        methods: {
          getCartList() {
              const params = {};
              cartList(params).then((res) => {
                console.log(res, 'cartList');
                this.cartList = res;
              });
          },
          handleChange(row) {
            console.log(row, 'ddd');
            const params = {
              productId: row.productId,
              num: row.num,
            }
            cartAdd(params).then((res) => {
              console.log(res, 'cartAdd');
              this.getCartList();
            });
          },
          // handleSelectionChange(item) {
          //   this.multipleSelection = item;
          //   if (item.length == this.cartList.length) {
          //     this.checked = true;
          //   } else {
          //     this.checked = false;
          //   }
          //   this.sumitList = []
          //   item.forEach(v=> {
          //     this.sumitList.push({ productId: v.productId, num: v.num })
          //   })
          //   console.log(this.sumitList, 'this.sumitList');
          // },
          handleSelectionChange(item) {
            this.multipleSelection = item;
            if (item.length == this.cartList.length) {
              this.checked = true;
            } else {
              this.checked = false;
            }
          },
          checkAll() {
            if (this.checked == true) {
              this.$refs.multipleTable.clearSelection();
              this.$refs.multipleTable.toggleAllSelection();
            } else {
              this.$refs.multipleTable.clearSelection();
            }
          },
          sumbitCart() {
            if(!this.multipleSelection.length){
              // 此处提示未勾选什么的
              return
            }
            this.sumitList =  this.multipleSelection.map(v =>({ productId: v.productId, num: v.num }))
            // this.$router.push({
            //   path: './Payment',
            //   query: { products: this.sumitList }
            // });
            console.log(this.sumitList, 'this.sumitList');
            localStorage.setItem('sumitList', JSON.stringify(this.sumitList))
            this.$router.push({name: "Payment"});
          },
          // checkAll() {
          //   if (this.checked == true) {
          //     this.cartList.forEach(row => {
          //       this.$refs.multipleTable.toggleRowSelection(row);
          //     });
          //     this.sumitList = [];
          //     this.cartList.forEach(v=> {
          //       this.sumitList.push({ productId: v.productId, num: v.num })
          //     })
          //   } else {
          //     this.$refs.multipleTable.clearSelection();
          //     this.sumitList = [];
          //   }
          // },
          // sumbitCart() {
          //   this.$router.push({
          //     path: './Payment',
          //     query: { products: this.sumitList }
          //   });
          // }
        },
        mounted() {
          this.getCartList();
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
/* ::v-deep .el-input::-webkit-scrollbar {
  border-radius:20px;
}
::v-deep .el-input-number__decrease {
  border-radius:20px 0 0 20px;
  background-color: #fff;
}
::v-deep .el-input-number {
  border-radius:20px !important;
}
::v-deep .el-input::-webkit-scrollbar-thumb {
  border-radius:20px !important;
} */
::v-deep .el-checkbox__label {
  font-size:20px;
}
</style>